export default __webpack_public_path__ + "static/media/pen.c5172d2b.svg";